module.exports = __webpack_public_path__ + "static/inside_video_3-d730be8542f3bace6f77823739f0753b.mp4";